import { api } from '../index';
import { BundleTypeKeys } from '@/store';

export interface ChronologyEntryFromBundleRequest {
  caseId: string;
  pageIds: string[];
  bundleTypeToAddFrom: BundleTypeKeys;
  chronologyEntry: {
    date: string;
    time: string | null;
    verbatimExtract: string;
    comment: string;
  };
}

export interface ChronologyEntryFromBundleResponse {
  entryId: string;
}

export const addToChronologyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createChronologyFromSelection: builder.mutation<
      ChronologyEntryFromBundleResponse,
      ChronologyEntryFromBundleRequest
    >({
      query: (body) => ({
        url: '/chronology/entry/create-from-bundle',
        method: 'POST',
        //change bundleTypeToAddFrom to Uppercase
        body: {
          ...body,
          bundleTypeToAddFrom: body.bundleTypeToAddFrom.toUpperCase()
        }
      })
    })
  })
});
export const { useCreateChronologyFromSelectionMutation } = addToChronologyApi;
